@if (
  field.name !== 'employee' || (loadedData() && loadedData().employee?.name === '')
) {
  <fieldset [formGroup]="parentForm" class="fieldset w-full">
    <legend class="fieldset-legend">{{ field.label }}</legend>

    @if (!isCreating()) {
      <!-- MODE SÉLECTION -->
      <ng-select
        [formControlName]="field.name"
        [items]="(employees$ | async) ?? []"
        placeholder="Sélectionner un salarié..."
        bindLabel="name"
        [fixedPlaceholder]="true"
        [compareWith]="compareValueSelect"
      >
        @if (allowCreation) {
          <ng-template ng-notFound-tmp let-searchTerm="searchTerm">
            <div class="p-2 text-center">
              <p class="text-sm text-gray-500 mb-2">Aucun résultat pour "{{ searchTerm }}"</p>
              <button
                type="button"
                class="text-sm text-blue-600 hover:underline font-medium cursor-pointer"
                (click)="enableCreationMode()"
              >
                + Créer un nouveau salarié
              </button>
            </div>
          </ng-template>
        }
      </ng-select>

      <div class="mt-1 flex justify-between items-center text-xs">
        <p class="label-text wrap-break-word text-gray-400">
          {{ field.helper || '' }}
        </p>

        @if (allowCreation) {
          <button
            type="button"
            class="text-blue-600 hover:underline cursor-pointer"
            (click)="enableCreationMode()"
          >
            Salarié non trouvé ? Ajouter-le
          </button>
        }
      </div>

    } @else {

      <!-- MODE CRÉATION RAPIDE -->
      <div [formGroup]="newEmployeeForm" class="p-3 border rounded-md bg-gray-50 border-gray-200 space-y-3 mt-1">
        <div class="flex justify-between items-center">
          <span class="text-xs font-semibold text-gray-600 uppercase">Nouveau salarié</span>
          <button
            type="button"
            class="text-xs text-red-500 hover:underline cursor-pointer"
            (click)="cancelCreationMode()"
          >
            Annuler / Choisir un salarié existant
          </button>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-2">
          <div>
            <label class="block text-xs text-gray-600 mb-1">Nom</label>
            <input
              type="text"
              formControlName="lastName"
              placeholder="Nom"
              class="input input-bordered w-full text-sm"
            />
          </div>

          <div>
            <label class="block text-xs text-gray-600 mb-1">Prénom</label>
            <input
              type="text"
              formControlName="firstName"
              placeholder="Prénom"
              class="input input-bordered w-full text-sm"
            />
          </div>

          <div>
            <label class="block text-xs text-gray-600 mb-1">Email</label>
            <input
              type="email"
              formControlName="email"
              placeholder="email@exemple.com"
              class="input input-bordered w-full text-sm"
            />
          </div>
        </div>
      </div>
    }
  </fieldset>
}
